/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
// import store from '@/store/index';
export const ProjectOverviewMixin = {
  data: () => ({
    projectLineCountMobile: 1,
    projectLineCountMedium: 2,
    projectLineCountDesktop: 3,
    activeProjects: [],
    multiproject: [],
    positionDesktop: [ [2, -2, 1, -1, 3, -3, 4, -4],
                      [-2, -2, -1, -1, -3, -3, -4, -4],
                      [-2, -2, 6, -6, -3, -3, 5, -5],
                      [8, -8, 7, -7, -7, -7, -5, -5],
                      [-8, -8, -7, -7, -7, -7, 9, -9],
                      [0, 0, 0, 0, 0, 0, -9, -9],
                      [0, 0, 0, 0, 0, 0, -9, -9]
    ],
    positionDesktopInvites: [
                      [4, -4, 1, -1, 5, -5, 9, -9],
                      [-4, -4, -1, -1, -5, -5, -9, -9],
                      [2, -2, 6, -6, 3, -3, -9, -9],
                      [-2, -2, 0, 0, -3, -3, 8, -8],
                      [-2, -2, 0, 0, -3, -3, -8, -8],
                      [0, 0, 7, -7, -7, -7, 0, 0],
                      [0, 0, -7, -7, -7, -7, 0, 0],
    ],
    positionMedium: [ [4, -4, 5, -5],
                      [-4, -4, -5, -5],
                      [8, -8, 3, -3],
                      [-8, -8, -3, -3],
                      [2, -2, -3, -3],
                      [-2, -2, 0, 0],
                      [-2, -2, 0, 0]
    ],
    positionMobile: [ [4, -4],
                      [-4, -4],
                      [5, -5],
                      [-5, -5],
                      [8, -8],
                      [-8, -8],
                      [2, -2],
                      [-2, -2],
                      [-2, -2],
                      [3, -3],
                      [-3, -3],
                      [-3, -3]
    ],
    containers: [
      {id: 1, widget: 'logo', width: 0, height: 0, position: false, color: 'yellow'},
      {id: 2, widget: 'loglist', width: 0, height: 0, position: false, color: 'blue'},
      {id: 3, widget: 'images', width: 0, height: 0, position: false, color: 'green'},
      {id: 4, widget: 'warnings', width: 0, height: 0, position: false, color: 'red'},
      {id: 5, widget: 'notifications', width: 0, height: 0, position: false, color: 'red'},
      {id: 6, widget: 'update', width: 0, height: 0, position: false, color: 'green'},
      {id: 7, widget: 'community', width: 0, height: 0, position: false, color: 'green'},
      {id: 8, widget: 'qrcode', width: 0, height: 0, position: false, color: 'green'},
      {id: 9, widget: 'invitations', width: 0, height: 0, position: false, color: 'red'},
      // {id: 5, widget: 'algorithmicFlow', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 6, widget: 'social', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 7, widget: 'training', width: 1, height: 1, position: false, color: 'red'},

      // {id: 8, widget: 'workbench', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 9, widget: 'taktNews', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 10, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 11, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 12, widget: 'taktPartners', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 13, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 14, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 15, widget: 'processBoards', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 16, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 17, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 18, widget: 'piktoOne', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 19, widget: 'piktoTwo', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 19, widget: 'two', width: 0.5, height: 1, position: false, color: 'blue'},
      // {id: 20, widget: 'taktConnection', width: 0.5, height: 1, position: false, color: 'blue'},

      // {id: 21, widget: 'knowledge', width: 0.5, height: 1, position: false, color: 'blue'},
      // {id: 22, widget: 'taktPower', width: 0.5, height: 1, position: false, color: 'blue'},
    ],
    min_res: 1,
  }),
  // created() {
  //   let calls = [
  //     store.dispatch('Ultra/requestUObject', {
  //       url: [
  //         {projects: ''},
  //         {showWithEntitiesNormalized: ''}
  //       ]
  //     })
  //   ];
  //   Promise.all(calls).then( () => {
  //     this.setPosition();
  //   });
  // },
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
    ]),
    ...mapGetters('Project', [
      'getProjectOverview',
    ]),
    ...mapActions('Ultra', [
      'requestUObject'
    ]),
    columns() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return this.projectLineCountMobile * this.min_res;
        case 'sm': return this.projectLineCountMedium * this.min_res;
        case 'md': return this.projectLineCountDesktop * this.min_res;
        case 'lg': return this.projectLineCountDesktop * this.min_res;
        case 'xl': return this.projectLineCountDesktop * this.min_res;
      }
    },
    // matrix() {
    //   switch (this.$vuetify.breakpoint.name) {
    //     case 'xs': return this.positionMobile;
    //     case 'sm': return this.positionMedium;
    //     case 'md':
    //       if (this.getProjectInvites.length) {
    //         return this.positionDesktopInvites;
    //       }
    //       return this.positionDesktop;
    //     case 'lg':
    //       if (this.getProjectInvites.length) {
    //         return this.positionDesktopInvites;
    //       }
    //       return this.positionDesktop;
    //     case 'xl':
    //     if (this.getProjectInvites.length) {
    //       return this.positionDesktopInvites;
    //     }
    //     return this.positionDesktop;
    //   }
    // }
  },
  watch: {
    '$vuetify.breakpoint.name'() {
      this.setPosition();
    },
  },
  methods: {
    setPosition() {
      this.activeProjects = [];
      for (var i = 0; i < this.getUObjects({type: 'projects'}).length; i++) {
        this.activeProjects.push(this.getUObjects({type: 'projects'})[i]);
        if (i < 4) {
          this.multiproject.push(this.getUObjects({type: 'projects'})[i]);
        }
      }
    }
  }
};
